<template>
    <div class="verifyBox">
        <div class="verifyTitle">
            <p class="verifyTitle_tit">版权家验证中心</p>
            <img src='./image/heyandian.png' class="verifyTitle_img"/>
            <p class="verifyTitle_txt">核验内容仅支持在版权家平台保存的证据文件和证书</p>
        </div>
        <div>
            <Tabs active-key="key1" @on-click="changeTabs">
                <Tab-pane label="证据文件核验" key="key1">
                    <document-verification ref="verifyOne"></document-verification>
                </Tab-pane>
                <Tab-pane label="证书编号核验" key="key2">
                    <code-verification ref="verifyTwo"></code-verification>
                </Tab-pane>
            </Tabs>
        </div>
        <div><Spin size="large" fix v-if="spinShow"></Spin></div>
    </div>
</template>
<script>
    import documentVerification from './document-verification';
    import codeVerification from './code-verification';
    export default {
        name:'verificationCenter',
        components:{
            documentVerification,
            codeVerification
        },
        data() {
            return {
                spinShow:false
            }
        },
        methods: {
            // spinShowTFn(){
            //     this.spinShow = true
            // },
            // spinShowFFn(){
            //     this.spinShow = false
            // },
            changeTabs(val){
                if(val==0){
                    this.$refs.verifyOne.initFunc();
                }else if(val==1){
                    this.$refs.verifyTwo.initFunc();            
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .verifyBox{
        width: 1334px;
        margin: auto;
        .verifyTitle{
            .verifyTitle_tit{
                font-size: 24px;
                color: #000000;
                line-height: 33px;
                margin-top: 60px;
                text-align: center;
            }
            .verifyTitle_img{
                width: 296px;
                height: 5px;
                display: block;
                margin:16px auto 20px;
            }
            .verifyTitle_txt{
                font-size: 16px;
                color: #999999;
                line-height: 22px;
                text-align: center;
                padding-bottom: 60px;
                box-sizing: border-box;
            }
        }
        /deep/ .ivu-tabs-bar{
            margin-bottom: 60px;
            border-color: #EDEDED;
        }
        /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
            font-size: 16px;
            font-weight: 600;
            color: #212121;
        }
        /deep/ .ivu-tabs-ink-bar{
            width: 64px !important;
            height: 3px;
            background: #FFD800;
            border-radius: 2px;
            left: 30px;
        }
        /deep/ .ivu-tabs-nav .ivu-tabs-tab{
            font-size: 16px;
            color: #666666;
            line-height: 22px;
            padding: 0 16px 20px;
            &:hover{
                color: #212121;
            }
        }
        
    }
</style>
